import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';

// Error Panel Data Set
const error = {
  header: i18n.message('smarthelp/Error.error.article.header'),
  tryAgain: i18n.message('smarthelp/Error.error.article.tryAgain'),
  home: i18n.message('smarthelp/Error.error.article.home'),
};

const cobrand = Page.getCountry();
const homePage = `/${cobrand}/smarthelp/home`;

// HCR Error Page with blue font color
const ErrorPanel = (props) => {
  function clickHandle(pageName, link) {
    trackLink({ id: pageName, link });
  }

  return (
    <div className="article-error-container">
      <div className="vx_icon vx_icon-large vx_icon-info-large error-icon" />
      <h2 className="article-error-heading">{error.header}</h2>
      <div className="article-error-body">
        <span className="article-error-message">{error.tryAgain} </span>
        <a
          href={props.homePage}
          onClick={() => clickHandle(props.pageName, props.link)}
          className="article-error-home"
        >
          {error.home}
        </a>
      </div>
    </div>
  );
};

ErrorPanel.propTypes = {
  homePage: PropTypes.string,
  pageName: PropTypes.string,
  link: PropTypes.string,
};

ErrorPanel.defaultProps = {
  homePage,
  pageName: 'articleErrorPage',
  link: 'smarthelp-error-page|redirect-to-home-page',
};

export default ErrorPanel;
